import { render, staticRenderFns } from "./CargoEdit.vue?vue&type=template&id=5141c19f&scoped=true&"
import script from "./CargoEdit.vue?vue&type=script&lang=js&"
export * from "./CargoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141c19f",
  null
  
)

export default component.exports